// routes.js
const ROUTES = {
  home: "/",
  termsOfUsage: "/terms-of-use",
  contactUs: "/contact-us",
  partners: "/lending-partners",
  privacyPolicy: "/privacy-policy",
  dndService: "/unsubscribe",
  personalLoan: "/personal-loan",
  businessLoan: "/business-loan",
  goldLoan: "/gold-loan",
};

export default ROUTES;
